<template lang="">
  <div v-if="validBatch" class="w-full">
    <div class="flex flex-row justify-between m-12 p-3">
      <div class="flex flex-row" style="width: 150px">
        <a @click="back">
          <ArrowCircleLeftIcon
            class="m-1 w-full h-12 rounded-sm label text-button text-xs"
          />
        </a>
      </div>
      <div class="text-3xl">Batch Users</div>
      <div class="flex flex-row" style="width: 150px">
        <button
          v-if="$store.state.permissions.addProject"
          @click="displayUserModal = true"
          class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
        >
          Add User
        </button>
      </div>
    </div>
    <div class="justify-center">
      <GoodTable
        :name="'projectusers'"
        :rows="users"
        :columns="columns"
        @removeUser="removeBatchUsers"
      />
    </div>
    <GiveAccessModal
      v-if="displayUserModal"
      :selectedUsers="users"
      :projectId="parseInt(id)"
      :allUsers="allUsers"
      name="batches"
      @updateUsers="updateParent"
      @close="displayUserModal = false"
    />
  </div>
  <div v-else class="w-full">
    <NotFound />
  </div>
</template>
<script>
import Http, { OCR_ENDPOINTS } from "../request";
import GoodTable from "../components/GoodTable.vue";
import GiveAccessModal from "../components/GiveAccessModal.vue";
import NotFound from "../views/404.vue";
import { ArrowCircleLeftIcon } from "@vue-hero-icons/outline";
export default {
  components: {
    GoodTable,
    GiveAccessModal,
    NotFound,
    ArrowCircleLeftIcon,
  },
  data() {
    return {
      projectId: null,
      displayUserModal: false,
      id: null,
      validBatch: true,
      users: [],
      //   users: [],
      allUsers: [],
      columns: [
        {
          label: "ID",
          field: "id",
          type: "number",
        },
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Username",
          field: "username",
        },

        {
          label: "Actions",
          field: "actions",
          sortable: false,
        },
      ],
    };
  },

  created() {
    this.getIDfromURL();
  },

  methods: {
    back() {
      this.$router.push("/batches");
    },

    updateParent(newData) {
      this.users = newData;
    },
    getProjectUsers() {
      Http()
        .get(OCR_ENDPOINTS.projects + this.projectId + "/users", {
          params: {
            page: 0,
            size: 1000,
          },
          showLoader: false,
        })
        .then((response) => {
          this.allUsers = response.data;
        })
        .finally(() => {});
    },
    getBatchesUsers() {
      Http()
        .get(OCR_ENDPOINTS.batches + this.id + "/users", {
          params: {
            page: 0,
            size: 1000,
          },
          showLoader: true,
        })
        .then((response) => {
          this.users = response.data.users;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },
    addBatchesUsers(userId) {
      Http()
        .post(OCR_ENDPOINTS.batches + this.id + "/users", {
          userIdList: userId,
        })
        .then((response) => {
          this.users = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },
    removeBatchUsers(userId) {
      Http()
        .patch(OCR_ENDPOINTS.batches + this.id + "/users", {
          userIdList: [userId],
        })
        .then((response) => {
          this.users = response.data.users;
          this.$toast.success("User removed succesfully");
        })
        .catch((error) => {
          this.$toast.error(error.response.data);
        })
        .finally(() => {});
    },
    getIDfromURL() {
      this.id = window.location.pathname.split("/")[2];

      Http()
        .get(OCR_ENDPOINTS.batches + `${this.id}`, {
          showLoader: false,
        })
        .then((response) => {
          this.validBatch = true;
          this.projectId = response.data.project.id;
          this.getBatchesUsers();
          this.getProjectUsers();
        })
        .catch((error) => {
          this.validBatch = false;
        })
        .finally(() => {});
    },
  },
};
</script>
<style lang=""></style>
